/* eslint-disable no-unused-vars */
import React, {
    useEffect,
    // useState, useMemo, useRef - not currently used, only needed by the disabled location/text-filter UI
    // further down (see the commented-out state/effects below) - restore these if that UI is reintroduced.
} from 'react';
// import { useHistory } from 'react-router-dom'; - not currently used, only needed by the disabled filter UI below
import PropTypes from 'prop-types';
import animateScrollTo from 'animated-scroll-to';
import exact from 'prop-types-exact';
// import makeAnimated from 'react-select/animated'; - not currently used, only needed by the disabled filter UI below
import Spinner from '../../../common/Spinner/Spinner';
import ClientsCardComponent from './ClientsCardComponent';

// The location/text filter UI below is disabled (its JSX is commented out further down in the render),
// so buildLocationOptions/locationOptions/selectedLocations/clientsFilter and the effects that fed them
// are commented out too - kept for reference in case this filter UI is reintroduced.
// const buildLocationOptions = (locations) => {
//     // Map all the available options for React Select
//     const options = locations.map((location) => ({ value: location, label: location }));

//     // Add an option for the clients that do not have any praça
//     options.push({ value: 'noLocation', label: 'Sem Praça' });

//     return options;
// };

const ClientsComponent = ({ clientsData, allLocations, isLoadingClientsData, getClientsDataIfNeeded }) => {
    // filteredClientsData always equals clientsData unmodified now that the filter UI below is disabled -
    // see the commented-out state/effects further down for how this used to be a separate, user-filterable state.
    const filteredClientsData = clientsData;
    // const [showFilters, setShowFilters] = useState(true); // Note: We need to mount the filter component opened, or we cant get its height...
    // const [clientsFilter, setClientsFilter] = useState('');
    // const [locationOptions, setLocationOptions] = useState(() => buildLocationOptions(allLocations));
    // const [selectedLocations, setSelectedLocations] = useState(() => buildLocationOptions(allLocations));
    // const filterContainerRef = useRef(null);
    // const [filterContainerHeight, setFilterContainerHeight] = useState(false);
    // const [filterContainerOverflow, setFilterContainerOverflow] = useState('hidden');

    useEffect(() => {
        animateScrollTo(0, { speed: 700 });

        getClientsDataIfNeeded();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // useEffect(() => {
    //     // Re-sync options if allLocations changes after mount (e.g. after a re-fetch)
    //     const _locationOptions = buildLocationOptions(allLocations);

    //     setLocationOptions(_locationOptions);

    //     setSelectedLocations(_locationOptions);

    //     // if (allLocations.size > 0) {
    //     //     // Once allLocations has been loaded, get the height of the filter options div
    //     //     // Note: This needs a short timeout, as React Select apparently needs a bit of time to reload with the new selected options
    //     //     setTimeout(() => {
    //     //         setFilterContainerHeight(filterContainerRef.current.clientHeight);

    //     //         // Hide it after a short timeout, to not interfere with the scrollToTop animation
    //     //         setTimeout(() => setShowFilters(false), 700);
    //     //     }, 100);
    //     // }
    // }, [allLocations]);

    // useEffect(() => {
    //     if (showFilters) {
    //         // the filters will now slide down. Once finished, show the overflow to not cut off the Select drop down
    //         setTimeout(() => setFilterContainerOverflow('visible'), 300);
    //     } else {
    //         // the filters will now slide up, hide the overflow so that the filters are hidden
    //         setFilterContainerOverflow('hidden');
    //     }
    // }, [showFilters]);

    // // Custom react-select style
    // const customStyle = useMemo(() => ({
    //     container: (styles) => ({
    //         ...styles,
    //     }),
    //     control: (styles) => ({
    //         ...styles,
    //         border: '1px solid #ced4da',
    //         // This line disable the blue border
    //         boxShadow: 'none',
    //         '&:hover': {
    //             border: '1px solid #ced4da',
    //         },
    //         alignItems: 'stretch',
    //     }),
    //     indicatorsContainer: () => ({
    //         display: 'flex',
    //         flexDirection: 'column',
    //         justifyContent: 'space-between',
    //         background: 'linear-gradient(30deg, #325596, #253d69)',
    //         borderTopRightRadius: 3,
    //         borderBottomRightRadius: 3,
    //     }),
    //     loadingIndicator: () => ({
    //         display: 'none',
    //     }),
    //     menu: (styles) => ({
    //         ...styles,
    //         border: '1px solid #ced4da',
    //         boxShadow: '0 7px 12px rgba(0,0,0,0.6)',
    //         overflow: 'hidden',
    //     }),
    //     placeholder: (styles) => ({
    //         ...styles,
    //         color: '#ff6060',
    //     }),
    // }), []);

    // useEffect(() => {
    //     // first filter by the selected locations
    //     const locationFilteredClients = clientsData.reduce((filteredClients, client) => {
    //         const clientLocations = client.locations;

    //         // compare the two arrays, selectedLocations and clientLocations and check if there are any matches
    //         if (selectedLocations && selectedLocations.some((location) => clientLocations.includes(location.value))) {
    //             filteredClients.push(client);

    //             return filteredClients;
    //         }

    //         // add all the clients that have no location at all, if this option was selected.
    //         if (selectedLocations && selectedLocations.find((location) => location.value === 'noLocation')) {
    //             if (clientLocations.length === 0) {
    //                 filteredClients.push(client);

    //                 return filteredClients;
    //             }
    //         }

    //         return filteredClients;
    //     }, []);

    //     // then, if any, filter by free text search
    //     if (clientsFilter !== '') {
    //         const newFilteredClientsData = locationFilteredClients.reduce((filteredClients, client) => {
    //             const clientName = client.name.toLowerCase();

    //             if (clientName.includes(clientsFilter.toLowerCase())) {
    //                 filteredClients.push(client);

    //                 return filteredClients;
    //             }

    //             return filteredClients;
    //         }, []);

    //         setFilteredClientsData(newFilteredClientsData);
    //     } else {
    //         setFilteredClientsData(locationFilteredClients);
    //     }
    // }, [clientsData, clientsFilter, selectedLocations]);

    // const animatedComponents = makeAnimated();

    const getSegment = (client) => {
        if (client.name.includes('Assaí') || client.name.includes('Restaurante')) {
            return 'Estabelecimentos';
        }

        if (client.name.includes('Cofap') || client.name.includes('Harley Davidson') || client.name.includes('Porsche Cup')) {
            return 'Automotivo';
        }

        if (client.name.includes('Beto Carrero') || client.name.includes('Boat Show') || client.name.includes('LAURA PAUSINI WORLD TOUR') || client.name.includes('Mesa São Paulo') || client.name.includes('Uma Linda Mulher - O MUSICAL') || client.name.includes('China Homelife Brazil') || client.name.includes('Tickets for Fun') || client.name.includes('Teatro Liberdade')) {
            return 'Cultura e Entretenimento';
        }

        if (client.name.includes('Air Europa') || client.name.includes('Minas Gerais') || client.name.includes('United Airlines') || client.name.includes('Governo de Minas-Secult')) {
            return 'Turismo';
        }

        if (client.name.includes('Rocha Branca') || client.name.includes('Kopenhagen') || client.name.includes('Aurora') || client.name.includes('Rocha  Branca')) {
            return 'Alimentos e Bebidas'
        }

        return 'Serviços';
    };

    // Categorizar os clientes em segmentos
    const categorizedClients = {
        Estabelecimentos: [],
        Automotivo: [],
        'Cultura e Entretenimento': [],
        Serviços: [],
        Turismo: [],
        'Alimentos e Bebidas': [],
    };

    // clone each client with its computed segment attached: the objects in filteredClientsData come
    // straight from the (frozen-in-dev) Redux store now that clientsData is a plain array (RTK/Immer),
    // so segment can no longer be mutated onto them in place like before - build a new array instead,
    // and pass THIS segmented array down (not the original filteredClientsData) so the child component's
    // `client.segment === title` check has something to match against.
    const segmentedClientsData = filteredClientsData.map((clientData) => ({ ...clientData, segment: getSegment(clientData) }));

    segmentedClientsData.forEach((clientData) => {
        const { segment } = clientData;

        switch (segment) {
            case 'Estabelecimentos':
                categorizedClients.Estabelecimentos.push(clientData);

                break;

            case 'Automotivo':
                categorizedClients.Automotivo.push(clientData);

                break;

            case 'Cultura e Entretenimento':
                categorizedClients['Cultura e Entretenimento'].push(clientData);

                break;

            case 'Turismo':
                categorizedClients.Turismo.push(clientData);

                break;

            case 'Alimentos e Bebidas':
                categorizedClients['Alimentos e Bebidas'].push(clientData);

                break;

            default:
                categorizedClients.Serviços.push(clientData);

                break;
        }
    });

    return (
        <section className="sectionClients">
            <header className="header">
                <h1>Nossos clientes</h1>
                <p className="pageSubtitle">Saiba mais sobre as marcas que anunciam em nossa programação</p>
            </header>
            {/* <div className="clientsFilterContainer">
                <Button
                    className="filterToggle"
                    title={showFilters ? 'Esconder filtros' : 'Mostrar filtros'}
                    onClick={() => setShowFilters(!showFilters)}
                >
                    {showFilters ? 'Esconder filtros' : 'Mostrar filtros'}
                    <FontAwesomeIcon icon={showFilters ? faAngleUp : faAngleDown} width="16" />
                </Button>
                <div
                    ref={filterContainerRef}
                    className="clientsFilterOptionsContainer"
                    style={{
                        height: filterContainerHeight === false ? 'auto' : showFilters ? filterContainerHeight : 0,
                        overflow: filterContainerOverflow,
                    }}
                >
                    <div className="clientsFilterNameContainer">
                        <input className="form-control" placeholder="Filtrar" type="text" value={clientsFilter} onChange={(event) => setClientsFilter(event.target.value)} />
                    </div>
                    <Select
                        id="clientsLocationSelect"
                        instanceId="clientsLocationSelect"
                        key={JSON.stringify(locationOptions)}
                        closeMenuOnSelect={false}
                        styles={customStyle}
                        components={{ ...animatedComponents, IndicatorSeparator: () => null }}
                        options={locationOptions}
                        defaultValue={locationOptions}
                        onChange={(selectedOptions) => setSelectedLocations(selectedOptions)}
                        isSearchable={false}
                        isMulti
                        placeholder="Escolhe uma ou mais praças"
                        noOptionsMessage={({ inputValue }) => (!inputValue ? 'Não há mais opções' : 'Não há mais opções')} // Not exactly sure how this works, to be honest...
                    />
                </div>
            </div> */}
            {
                clientsData.length === 0 && isLoadingClientsData
                    ? <Spinner />
                    : filteredClientsData.length > 0 &&
                        <div className="clientsContainer">
                            {Object.keys(categorizedClients).map((segmentKey) => {
                                const clientsInSegment = categorizedClients[segmentKey];

                                // Verifica se existem clientes no segmento
                                if (clientsInSegment.length > 0) {
                                    return (
                                        <ClientsCardComponent
                                            key={segmentKey}
                                            title={segmentKey}
                                            filteredClientsData={segmentedClientsData}
                                        />
                                    )
                                }
                            })}
                        </div>
            }

            {/* <Button title="Ir para a página Anuncie Conosco" className="btnAnuncie" to="/anuncie-conosco">Anuncie conosco</Button> */}
        </section>
    );
};

ClientsComponent.propTypes = exact({
    clientsData: PropTypes.arrayOf(PropTypes.object).isRequired,
    allLocations: PropTypes.arrayOf(PropTypes.string).isRequired,
    getClientsDataIfNeeded: PropTypes.func.isRequired,
    isLoadingClientsData: PropTypes.bool.isRequired,

});

export default ClientsComponent;
